<template>
  <div :class="s.wrap">
    <GlobalHeader :isDarkBackground="false" />

    <div :class="s.container">
      <div :class="s.content">
        <div :class="s.code">404</div>
        <h1 :class="s.title">ページが見つかりませんでした</h1>
        <p :class="s.description">
          お探しのページは、移動または削除された可能性があります。<br />
          お手数ですが、URLをご確認ください。
        </p>
        <router-link :class="s.link" to="/">トップページへ戻る</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalHeader from '@/components/layouts/GlobalHeader.vue';

export default {
  components: {
    GlobalHeader,
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  min-height: 100vh;
}
.container {
  padding: calc(var(--header-height) + 24px) 24px 80px;
  max-width: 800px;
  margin: 0 auto;
  @include mdView {
    padding-top: calc(var(--md-header-height) + 24px);
  }
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 40px;
}
.code {
  font-size: 72px;
  font-weight: bold;
  line-height: 1;
  color: var(--theme-blue);
  @include mdView {
    font-size: 56px;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin: 24px 0 0;
  @include mdView {
    font-size: 20px;
  }
}
.description {
  margin: 16px 0 0;
  line-height: 1.8;
}
.link {
  margin-top: 32px;
  display: inline-block;
  border-radius: 6px;
  padding: 12px 24px;
  background-color: var(--theme-blue);
  color: #ffffff;
}
</style>
